export enum UserAttributeKind {
  Number = 'Number',
  String = 'String',
  Email = 'Email',
  Boolean = 'Boolean',
  Date = 'Date',
  Unknown = 'Unknown',
}

export interface UserAttribute {
  created: string;
  datatype: UserAttributeKind;
  id: number;
  name: string;
  ruleType: string;
  siteId: string;
  lastSeen: string;
  updated: string | null;
}

export interface UserAttributeDeleteResponse {
  success: boolean;
}

export interface UserAttributeOptionType {
  name: string;
  kind: UserAttributeKind;
}
